import { RouteRecordRaw } from "vue-router";
import IndexPage from "../IndexPage.vue";

export default {
  path: "groups",
  children: [
    {
      path: "",
      name: "hotel.groups",
      component: IndexPage,
    },
    {
      path: ":id",
      name: "hotel.groups.edit",
      component: () => import("../EditPage.vue"),
    },
  ],
} as RouteRecordRaw;
